import { StateName } from "shared";
import { Dialog, DialogButton, DialogButtonGroup } from "../../Dialog";
import { Link } from "../../Link";

const viewOrModifyTagTaction = {
  action: "insurance_button_clicked",
  name: "manage_policies_componly_modal",
} as const;

const title = "This policy doesn't have an ID card";

type CompOnlyDialogProps = {
  stateName: StateName;
  managePolicyUrl: string;
  onClose: () => void;
};

export const CompOnlyDialog = ({
  stateName,
  managePolicyUrl,
  onClose,
}: CompOnlyDialogProps) => (
  <Dialog
    title={title}
    footer={
      <DialogButtonGroup>
        <DialogButton onClick={onClose} variant="primary" aria-hidden>
          Got it
        </DialogButton>
      </DialogButtonGroup>
    }
    onDismiss={onClose}
  >
    <p>
      You only have Comprehensive coverage for your {stateName} policy. This
      doesn’t cover damages while on the road, so an ID card isn’t issued. You
      can{" "}
      <Link
        href={managePolicyUrl}
        tagAction={viewOrModifyTagTaction}
        ariaLabel="view and modify your coverages"
      >
        view and modify your coverages here
      </Link>
      {"."}
    </p>
  </Dialog>
);
